import type { PageRef } from '@wix/editor-platform-sdk-types'
import {
  DATASET,
  ROUTER_DATASET,
  type EditorSDK,
} from '@wix/wix-data-client-common-standalone'

export const getCategoryPageDatasets = async ({
  editorSdkProxy,
  pageRef,
  presetCategoryCollectionName,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
  presetCategoryCollectionName: string
}) => {
  const allControllers = await editorSdkProxy.controllers.listControllers({
    pageRef,
  })

  let pageDatasets
  try {
    pageDatasets = await Promise.all(
      allControllers.map(async ({ controllerRef }) => ({
        controllerRef,
        data: await editorSdkProxy.controllers.getData({
          controllerRef: controllerRef,
        }),
      })),
    )
  } catch (error: unknown) {
    throw new Error('Failed to get dataset controller data for category page', {
      cause: error,
    })
  }

  const routerDatasetRef = pageDatasets.find(
    ({ data }) => data.type === ROUTER_DATASET,
  )!.controllerRef

  const regularDatasetRef = pageDatasets.find(
    ({ data }) =>
      data.type === DATASET &&
      data.config.dataset.collectionName !== presetCategoryCollectionName,
  )!.controllerRef

  const repeaterNavMenuDatasetRef = pageDatasets.find(
    ({ data }) =>
      data.type === DATASET &&
      data.config.dataset.collectionName === presetCategoryCollectionName,
  )!.controllerRef

  return {
    routerDatasetRef,
    regularDatasetRef,
    repeaterNavMenuDatasetRef,
  }
}
